
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/cricket/[slug]/info",
      function () {
        return require("private-next-pages/sports/cricket/[slug]/info/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/cricket/[slug]/info"])
      });
    }
  